var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list-chip",class:{ selected: _vm.selected },on:{"click":function($event){return _vm.handleClick(_vm.tag.id)}}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.tag.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }